import axios from 'axios';
// this will get refactored to use an API instead of window properties in the near future
const url = `//${window.location.host}/occ/v2/${window.ACC.siteUid}`;
const occAxiosConfig = {
  baseUrl: url,
};

export default axios.create({baseURL: occAxiosConfig.baseUrl});